"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validation = void 0; // ***** helpers ***** //
// The below sites will help you identify what a regex is matching for
// https://regexr.com/
// https://regexper.com/

/* --------------- UTILITIES : FORMS : VALIDATION --------------- */

var validation = {
  // +++ FALLBACK +++ //
  general: {
    test: null,
    message: 'You must fill in this field'
  },
  // +++ PASSWORD +++ //
  password: {
    test: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,150})/,
    message: 'You must enter a valid password'
  },
  newPassword: {
    test: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]<>?/|.:;_-])(?=.{8,150})/,
    message: 'Please complete the secure password recommendations'
  },
  confirmedPassword: {
    test: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]<>?/|.:;_-])(?=.{8,150})/,
    message: 'Please enter a valid password',
    comparemessage: 'Passwords don’t match.'
  },
  signinpassword: {
    test: /^(?=[\S\s]{8,150}$)[\S\s]*/,
    message: 'Please enter a valid password'
  },
  // +++ NAME +++ //
  name: {
    test: /^(?!\s)[a-zA-Z ]{2,150}$/,
    message: 'Please enter a valid name'
  },
  fname: {
    test: /^(?!\s)[a-zA-Z ]{2,150}$/,
    message: 'You must enter a valid first name',
    emptymessage: 'You can\'t leave your name empty!'
  },
  lname: {
    test: /^(?!\s)[a-zA-Z ]{2,150}$/,
    message: 'You must enter a valid last name',
    emptymessage: 'You can\'t leave your last name empty!'
  },
  // +++ CONTACT +++ //
  email: {
    test: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: 'sample@sample.com'
  },
  phone: {
    test: /^(?!\s)[0-9'\.\(\)\+\-\s\,]{2,20}$/,
    message: 'You must enter a valid phone number'
  },
  // +++ SITE +++ //
  domain: {
    test: /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,150})/,
    // with http protocol: [-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)
    message: 'Format should be http://www.sample.com'
  },
  // +++ LOCATION +++ //
  country: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    message: 'Please enter a valid country'
  },
  address: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/,
    message: 'You need to enter a valid address'
  },
  city: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    message: 'Please enter a valid city'
  },
  state: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    message: 'Please enter a valid state'
  },
  zip: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,12}$/,
    message: 'Please enter a valid zip code'
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.validation = validation;